import { OrganizationListWrapper } from "@/views/organizations/Style.ts";
import { useLocation } from "react-router-dom";

const Organization = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  console.log("query", query);
    return (
        <OrganizationListWrapper className="OrganizationListWrapper">
            List organizations
        </OrganizationListWrapper>
    );
};

export default Organization;